<template>
  <section class="services-area ptb-70">
    <div class="container-fluid p-0">
      <div class="overview-box">
        <div class="overview-content">
          <div class="content left-content">
            <h2>Bank Transfer as a Service</h2>
    
            <p>
             A unique bank account number is generated for every transaction which allows customers to transfer to that number as a means of payment for goods and services. Merchant receives a notification immediately without the need for a bank alert. Merchant account is settled appropriately at a specified time most convenient for the merchant. </p>
            <ul class="services-list">
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Not dependent on bank alerts
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Same day settlement
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Any transfer method applies
                </span>
              </li>
              <li>
                <span>
                  <i class="flaticon-check-mark"></i> Send from any bank or mobile wallet
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="overview-image">
          <div class="image">
            <img src="assets/img/3.png" alt="image" />
            
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
</style>